import Modal from '@src/common/Modal';
import React,{ useEffect, useState, useCallback } from 'react';
import { useDispatch,useSelector } from 'react-redux'
import FullPageLoader from '@common/FullPageLoader';
import { getAgentleadHistory } from '@store/slices/commonId';
import { formatDate } from '@src/config/helper';

interface HistoryModelProps {
    show: boolean;
    handleClose: () => void;
    leadDetail:Record<string,any>
}

const HistoryModel = ({show,handleClose,leadDetail}: HistoryModelProps) => {

    const [loading, setLoading] = useState(false);
    const [data,setData] = useState<any>([]);
     const dispatch: any = useDispatch();
     
    const getAgentleadHistoryData = useCallback(async () => {
        try {
          setLoading(true);
          const res: any = await dispatch(getAgentleadHistory({lead_id:leadDetail.leadId}));
          if(res.status===200){
            setData(res.data)
          }
          setLoading(false);
        } catch (error) {
          console.error("Failed to fetch master config:", error);
        }
        finally {
          setLoading(false);
        }
      }, [dispatch]);

    const DetailRow = ({ label, value,created_by_name }: { label: string; value: string,created_by_name:string }) => (
        <div className="detail-row">
            <span className="detail-label">{formatDate(new Date(label),'dd mon yyyy')}
                <p>{formatDate(new Date(label),'hh:mi A')}</p>
            </span>
            <span className="detail-value">
                {value}
                <p>{created_by_name}</p>
            </span>
        </div>
    );
    useEffect(() => {
       getAgentleadHistoryData(); 
    },[leadDetail])

    useEffect(() => {
        if (show) document.body.classList.add("overflow-hidden");
        return () => {
            document.body.classList.remove("overflow-hidden");
        }
    }, [show])

    return(
        <React.Fragment>
            <FullPageLoader show={loading} /> 
               <div className= {`model-outer`}>
                <Modal show={show} handleClose={handleClose}>
                    <div className="modal-header">
                    {
                        <h2>Application History</h2>
                    }
          </div>
           <div className="modal-body">

                    {
                        data?.length ? data?.map((row: any, index: number) => {
                                return (
                                    <div className="details col-md-12" key={index}>
                                        <DetailRow label={row.created_at} value={row.sub_title} created_by_name={row.created_by_name} />
                                    </div>
                                )
                            }):<div className="no-data-found">No Data Found</div>
                    }
           </div>
                </Modal>
               </div>
        </React.Fragment>
    );
}

export default HistoryModel;    